import React, { useState, useEffect, useMemo } from "react";
import "./index.less";
import { useLocation } from "react-router-dom";
import LocalizedLink from "@/components/LocalizedLink";
import { getLocaleFromPath, LOCALE, EN_PREFIX } from "@/utils/locale";
import { VerticalAlignTopOutlined,PhoneOutlined,QrcodeOutlined,CustomerServiceOutlined } from "@ant-design/icons";

const FixedLink = () => {
  const location = useLocation();
  const pathname = location?.pathname || '';
  const isEnglish = getLocaleFromPath(pathname) === LOCALE.EN;
  const [isVisible, setIsVisible] = useState(true);

  const copy = useMemo(
    () =>
      isEnglish
        ? {
            consult: "",
            consultHoverTitle: "One-on-One Dedicated Corporate Consultant",
            hours: "Business Hours: 9:00 AM – 6:00 PM",
            phone: "",
            qr: "",
          }
        : {
            consult: "合作咨询",
            consultHoverTitle: "一对一专业企业顾问",
            hours: "工作日 9:00-18:00",
            phone: "电话",
            qr: "二维码",
          },
    [isEnglish]
  );
  
  // 检查是否是首页（中文 / 英文）
  const isHomePage = pathname === '/' || pathname === EN_PREFIX;
  
  useEffect(() => {
    if (!isHomePage) {
      // 如果不是首页，始终显示
      setIsVisible(true);
      return;
    }
    
    // 如果是首页，根据滚动位置决定是否显示
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      // 如果滚动位置小于视口高度（banner区域），隐藏 FixedLink
      setIsVisible(scrollTop >= windowHeight);
    };
    
    // 初始检查
    handleScroll();
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isHomePage]);
  
  // 如果不显示，返回 null
  if (!isVisible) {
    return null;
  }
  
  return (
    <div className="FixedLink">
      {/* 合作咨询 */}
      {/* in-show和hover-show是两个状态，in-show是默认状态，hover-show是鼠标悬停状态 */}
      <LocalizedLink 
        className="link-us jump" 
        to="/about#email-content" 
        state={{ type: 2 }}
      >
        <div className="in-show">
          <CustomerServiceOutlined />
          <p>{copy.consult}</p>
        </div>
        <div className="hover-show">
          <h3>{copy.consultHoverTitle}</h3>
          <p>{copy.hours}</p>
        </div>
      </LocalizedLink>


       {/* 联系信息 */}
      <div className="message-us">
        <div className="phone cube">
          <div className="in-show">
            <PhoneOutlined />
            <p>{copy.phone}</p>
          </div>
          <div className="hover-show">
            <h3>400-855-2725</h3>
            <p>{copy.hours}</p>
          </div>
        </div>
        <div className="code cube">
          <div className="in-show">
            <QrcodeOutlined />
            <p>{copy.qr}</p>
          </div>
          <div className="hover-show">
            <img src={require("@/assets/scancode-1.jpg")} alt="" />
          </div>
        </div>
      </div>


      {/* 返回顶部 */}
      <div className="go-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <VerticalAlignTopOutlined />
      </div>
    </div>
  );
};

export default FixedLink;
